import React from "react";
import T from "prop-types";
import { renderIf } from "MODULES/shared/decorators";
import { Link } from "react-router-dom";

function RecentOrderRow({ record, type, title, rootLink }) {
  return (
    <tr>
      <th className="text-right">{title}</th>
      <td>
        <Link to={`/${rootLink}/${record[type].uuid || record[type].id}`}>
          <span>{record[type].code}</span>
        </Link>
      </td>
    </tr>
  );
}

RecentOrderRow.propTypes = {
  record: T.shape({}),
  type: T.string.isRequired,
  title: T.string.isRequired,
  rootLink: T.string.isRequired
};

export default renderIf(({ record, type }) => record[type])(RecentOrderRow);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/RecentOrderRow.jsx